export default "__VITE_ASSET__BZDQboWa__"